import { useMemo, useState } from 'react';
export function useExtractFilter(initialFilters, resetFilters) {
    const [type, setType] = useState(initialFilters?.type);
    const [flow, setFlow] = useState(initialFilters?.flow);
    const [startAt, setStartAt] = useState(initialFilters?.startAt);
    const [endAt, setEndAt] = useState(initialFilters?.endAt);
    const [minAmount, setMinAmount] = useState(initialFilters?.minAmount);
    const [maxAmount, setMaxAmount] = useState(initialFilters?.maxAmount);
    const disabledClearFilters = useMemo(() => {
        return (flow === resetFilters?.flow &&
            type === resetFilters?.type &&
            startAt === resetFilters?.startAt &&
            endAt === resetFilters?.endAt &&
            minAmount === resetFilters?.minAmount &&
            maxAmount === resetFilters?.maxAmount);
    }, [flow, type, startAt, endAt, minAmount, maxAmount, resetFilters]);
    const disabledApplyFilters = useMemo(() => {
        return (flow === initialFilters?.flow &&
            type === initialFilters?.type &&
            startAt === initialFilters?.startAt &&
            endAt === initialFilters?.endAt &&
            minAmount === initialFilters?.minAmount &&
            maxAmount === initialFilters?.maxAmount);
    }, [flow, type, startAt, endAt, minAmount, maxAmount, initialFilters]);
    return {
        type,
        setType,
        flow,
        setFlow,
        startAt,
        setStartAt,
        endAt,
        setEndAt,
        minAmount,
        setMinAmount,
        maxAmount,
        setMaxAmount,
        disabledClearFilters,
        disabledApplyFilters,
    };
}
